import * as React from 'react';

import { PORTAL_NAVBAR_DROPDOWN_ITEM } from 'bones/components/molecules/Navbar/constants';
import { NavbarSchema } from 'bones/components/molecules/Navbar/types';
import { noop } from 'bones/utils/noop';

export const DEFAULT_NAVBAR_SCHEMA: NavbarSchema = {
  dropdown: {
    items: [],
    selectedItem: PORTAL_NAVBAR_DROPDOWN_ITEM,
  },
  expand: {
    isExpanded: false,
    onClick: noop,
  },
};

export const NavbarSchemaContext = React.createContext<NavbarSchema>(
  DEFAULT_NAVBAR_SCHEMA
);

export const useNavbarSchema = () => {
  const schema = React.useContext(NavbarSchemaContext);
  return schema;
};
